'use client';

import type { FC } from 'react';
import { ImageComponent } from '@/components/Image';
import {
  ProgressBar,
  ValuePosition,
} from '@/components/progressBars/LinearProgressBar';
import { ProgressBarMode } from '@/components/progressBars/LinearProgressBar/styled';
import { useGetCommonStore } from '@/store/commonStore';
import { useBonanzaPromo } from '../../hooks';
import { ScBonanzaPromoDashboardContent } from './styled';

interface BonanzaPromoDashboardContentProps {
  onClick?: () => void;
}

export const BonanzaPromoDashboardContent: FC<
  BonanzaPromoDashboardContentProps
> = ({ onClick }) => {
  const useCommonStore = useGetCommonStore();

  const bonanzaProgressPercent = useCommonStore.use.bonanzaProgressPercent();
  const { isLockedPromo, isBonusIssued, characterByStatus, isLvl3 } =
    useBonanzaPromo();

  return (
    <ScBonanzaPromoDashboardContent
      $isBonusIssued={isBonusIssued}
      $isLockedPromo={isLockedPromo}
      $isLvl3={isLvl3}
      onClick={onClick}
    >
      {!isLockedPromo && (
        <ProgressBar
          borderRadius="20px"
          borderRadiusInner={'20px 0px 0px 20px'}
          height={20}
          minProgress={0}
          mode={
            isBonusIssued
              ? ProgressBarMode.GREEN_WHITE
              : ProgressBarMode.PRIMARY_GRAY
          }
          showTo={false}
          showValue={ValuePosition.CENTER}
          value={bonanzaProgressPercent}
          withUnits
        />
      )}
      {characterByStatus && (
        <ImageComponent
          alt="character"
          className={isLockedPromo ? 'characterLocked' : 'character'}
          height={40}
          src={characterByStatus?.image?.url || ''}
          width={40}
        />
      )}
    </ScBonanzaPromoDashboardContent>
  );
};
